export interface utilsStateInterface {
  firebase: any;
  googleAuthProvider: any;
}

const initState: utilsStateInterface = {
  firebase: null,
  googleAuthProvider: null,
};

const utilsReducer: any = (state = initState, action: any) => {
  switch (action.type) {
    case "UPDATE_FIREBASE":
      return {
        ...state,
        firebase: action.payload.firebase,
      };
    case "UPDATE_GOOGLE_AUTH_PROVIDER":
      return {
        ...state,
        googleAuthProvider: action.payload.googleAuthProvider,
      };
    default:
      return state;
  }
};

export default utilsReducer;
